<template>
  <div>
    <div class="row">
      <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
        <h3>Új jelszó igénylése</h3>
      </div>
    </div>
    <div class="row">
      <div class="col s12 offset-m1 m10 offset-l3 l6">
        {{infoText}}
      </div>
    </div>
    <form method="POST" autocomplete="on" id="password-form" action="/public/ajax/generate-password">
      <div class="row">
        <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
          <input required type="text" class="form-control" name="login" id="login" v-model="login">
          <label for="login">{{loginLabel}}</label>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
          <div class="row">
            <div class="input-field col s4">
              <a v-link="{path: '/'}" class="waves-effect waves-teal btn-flat">Vissza</a>
            </div>
            <div class="input-field col s8 right-align">
              <button v-on:click.prevent="submit()" class="btn waves-effect waves-light">
                Jelszó igénylése
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from 'jquery'
import 'parsleyjs'
import {patch} from '../../api'
import config from '../../config'
import 'material-design-icons-iconfont/dist/material-design-icons.scss'
import {success/* , error*/} from '../../flash-messages'
import db from '../../db'

export default { // TODO: captcha
  data() {
    return {
      login: null,
      viewConfig: {
        shouldUseNavbarWarningBackground: false,
        skin: '',
        couchDbEnabled: false
      }
    }
  },
  created() {
    this.viewConfig = db.get('viewConfig')
  },
  ready() {
    this.init()
  },
  computed: {
    loginLabel() {
      if (this.viewConfig.couchDbEnabled) {
        return 'Felhasználónév, email cím vagy telefonszám'
      }
      return 'Felhasználónév vagy email'
    },
    infoText() {
      if (this.viewConfig.couchDbEnabled) {
        return 'Kérjük adja meg felhasználónevét, email címét vagy telefonszámát. A regisztrált email címére vagy telefonszámára üzenetet küldünk a jelszó beállításával kapcsolatban.'
      }
      return 'Kérjük adja meg felhasználónevét vagy email címét. Regisztrált email címére rövidesen üzenetet küldünk a jelszó beállításával kapcsolatban.'
    }
  },
  methods: {
    init() {
    },
    submit() {
      const valid = $('form').parsley().validate()
      if (valid) {
        return patch('/public/ajax/generate-password', this.$data, (resp) => {
          this.$router.go(config.routes.login)
          success(`Jelszó-beállító email elküldve a ${resp.email} címre!`)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?4f7f0b1a